import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthInterceptor, AuthModule, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { ConfigService } from './identityconfig.service';

const authFactory = (configService: ConfigService) => {
  const config = configService.getConfig();
  return new StsConfigStaticLoader(config);
};

@NgModule({
    imports: [AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [ConfigService],
      },
      })],
      providers:[
        {provide:HTTP_INTERCEPTORS,useClass:AuthInterceptor,multi:true}
      ],
    exports: [AuthModule],
})
export class AuthConfigModule {}
